import React from "react";

import { DynamicButtonContent, DynamicButtonSettings, IconPack } from "../../models/app-data-model";
import ShIcon from "../sh-icon/sh-icon";
import ShLink from "../sh-link/sh-link";
import "./dynamic-button.scss";

export type DynamicButtonProps = {
  content: DynamicButtonContent;
  fullWidth?: boolean;
  iconPack?: IconPack[];
  buttonId?: string;
  cssClasses?: string;
  onClick?: () => Promise<void> | void;
  closeMenus?: boolean;
  nonFocusable?: boolean;
};

const DynamicButton: React.FC<DynamicButtonProps> = ({
  content,
  fullWidth,
  iconPack,
  cssClasses,
  onClick,
  closeMenus,
  nonFocusable
}: DynamicButtonProps) => {
  return (
    <ShLink
      className={`dynamic-button 
        ${cssClasses ? `${cssClasses} ` : ""}
        ${content?.settings?.button_type}-btn  
        color-${content?.settings?.color}   
        size-${content?.settings?.size} 
        ${content?.settings?.dark_mode ? "dark-mode" : ""} 
        ${content?.settings?.disabled ? "disabled" : ""}   
        ${fullWidth ? "full-width" : ""}`}
      reference={content?.reference || []}
      onClick={content?.settings?.disabled ? (e) => e.preventDefault() : onClick}
      iconPack={iconPack}
      featureToggles={[]}
      dataTestId="dynamicBtn"
      closeMenus={closeMenus}
      nonFocusable={nonFocusable}
    >
      {content?.text}
      {content?.icon && (
        <ShIcon
          iconPack={iconPack}
          iconName={content?.icon}
          className={`${content?.icon?.replace("_", "-")}-icon 
          ${content?.settings?.disabled}`}
        />
      )}
    </ShLink>
  );
};

export default DynamicButton;

export const smallNavListButtonSettings: DynamicButtonSettings = {
  button_type: "tertiary",
  color: "default",
  dark_mode: true,
  size: "small"
};

export const mediumNavListButtonSettings: DynamicButtonSettings = {
  button_type: "tertiary",
  color: "default",
  dark_mode: false,
  size: "medium"
};
